module.exports = __webpack_public_path__ + "img/visa.312d573d.png";